export default {
  name: 'ScheduleFormDialog',
  props: {
    forceReload: {
      type: Number,
      default: 0
    },
    dialogConfig: {
      type: Array,
      default: []
    }, // 表单数据
    detail: {
      type: Object,
      default: {}
    }, // 明细详情
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ID: this.$route.params.customizedModuleId && this.$route.params.customizedModuleId != 'New' ? this.$route.params.customizedModuleId : '-1', // 记录主界面传入的ID
      subTableCollapse: [],
      formConfig: {},
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: $it('com.cancel'), // 取消
            btnclick: () => {
              this.$parent.close();
              this.$emit('clearModify');
            },
          },
          {
            text: $it('com.determine'), // 确定
            type: 'primary',
            size: '', // 按钮大小
            disabled: false, // 按钮禁用控制
            btnclick: () => {
              this.confirmHandel();
            },
          },
        ]
      }
    };
  },
  watch: {
    dialogConfig: {
      handler(val) {
        const panelCounts = this.dialogConfig.length;
        this.subTableCollapse = panelCounts > 1 ? [...new Array(panelCounts).keys()] : [];
      },
      immediate: true
    }
  },
  mounted() {
    this.$emit('initForm'); // 表单初始化渲染
  },
  methods: {
    confirmHandel() {
      console.log(this.detail.ID);

      if (!this.validate()) return;
      let ID = this.detail.ID || -1;
      this.$emit('getData', { ID, ...this.formConfig.formValue });
    },
    // 表单校验
    validate() {
      const self = this;
      let flag = true;
      // 整合表单
      let formData = [];
      let formValue = {};
      let ruleValidate = {};
      this.dialogConfig.forEach(item => {
        formData = formData.concat(item.formConfig.formData);
        Object.assign(formValue, item.formConfig.formValue);
        Object.assign(ruleValidate, item.formConfig.ruleValidate);
      });
      this.formConfig = { formData, formValue, ruleValidate };

      const objKey = this.formConfig.formData.map(i => i.itemdata && i.itemdata.colname);
      const requiredArr = Object.keys(this.formConfig.ruleValidate).map(i => {
        if (this.formConfig.ruleValidate[i][0].required) return i;
      });
      const drpArr = requiredArr.filter(i => objKey.includes(i));
      const valueArr = requiredArr.filter(i => !drpArr.includes(i));
      const msg = $utils.validatorNotEmpty(self.formConfig, valueArr, drpArr);

      if (msg !== '') {
        $fcError(msg);
        flag = false;
      }
      return flag;
    }
  }
};
